import './cmslink.less'

import React, {CSSProperties, useState} from 'react'
import useSWR from 'swr'
import fetch from 'unfetch'
import {style} from 'util/style'

const styles = style('cmslink')

const CmslinkStyle: CSSProperties = {
	position: 'fixed',
	zIndex: 1000,
	top: '10px',
	right: '10px',
	color: 'black',
	fontSize: '14px',
	background: 'white',
	padding: '5px 15px',
	borderRadius: '3px',
	boxShadow: '0 0 15px rgba(0, 0, 0, 0.25)'
}

const fetcher = url => {
	return fetch(url).then(r => r.json())
}

// tslint:disable:no-string-literal
const fsDomain = window['__FS_DOMAIN__']

export const CMSLink: React.FC<{
	id: number
	project: string
}> = ({id, project}) => {
	const [isSyncing, setIsSyncing] = useState(false)
	const {data, error} = useSWR<any>('/api/is-cms-admin', fetcher, {
		onSuccess: data => {
			setIsSyncing(data.is_syncing)
			if (isSyncing && !data.is_syncing) {
				location.reload()
			}
		}
	})

	if (window.innerWidth < 800) return null
	if (!data || !data.is_admin || error) return null
	const href = `/admin/project/${project}/en/entry/${id}`

	return (
		<div
			className="cmslink_container"
			style={{
				position: 'fixed',
				zIndex: 1000,
				top: '10px',
				right: '10px'
			}}
		>
			<a href={href} className="cmslink" target="_blank">
				Edit in CMS
			</a>
			{fsDomain === 'futuresummits.imec.dev' && (
				<a
					className="cmslink"
					target="_blank"
					onClick={() => {
						if (isSyncing) {
							alert(
								'The environment is already being synced. This process will take around 2 minutes to complete. Data from staging will be overriden.'
							)
						} else {
							const response = window.confirm(
								'Sync staging environment with production? All CMS data will be overriden.'
							)
							if (response) {
								fetch('/api/sync-with-live')
								setIsSyncing(true)
							}
						}
					}}
				>
					{!isSyncing && (
						<>
							<span>Sync with live</span>
						</>
					)}
					{isSyncing && (
						<>
							<span>Syncing..</span>
							<Loader />
						</>
					)}
				</a>
			)}
		</div>
	)
}

const Loader: React.FC = () => {
	return (
		<div class="lds-ring">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
	)
}
